export default "__VITE_ASSET__DQZ3WsB0__"